import { t } from 'i18next'
import { MenuItem } from 'primereact/menuitem'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { USER_MANAGEMENT_PATHS } from './userManagement'

const FixationsPage = lazy(() => import('../containers/Fixations/FixationsContainer'));
const FixationsRequestsPage = lazy(() => import('../containers/Fixations/Requests/FixationsRequestsContainer'));

export const FIXATIONS_PATHS = {
  HOME: '/fixations',
  REQUESTS: '/fixations/requests'
} as const

export const fixationsRoutes: RouteObject[] = [
  {
    path: FIXATIONS_PATHS.HOME,
    children: [
      {
        index: true,
        element: <FixationsPage />,
        handle: {
          crumb: (): MenuItem[] => [
            { label: t('general:menu.fixations') || '', url: FIXATIONS_PATHS.HOME },
          ],
        },
      },
      {
        path: FIXATIONS_PATHS.REQUESTS,
        element: <FixationsRequestsPage />,
        handle: {
          crumb: (params: Record<string, string>): MenuItem[] => [
            { label: t('general:menu.fixations') || '', url: FIXATIONS_PATHS.HOME },
            { label: t('general:menu.fixations_requests') || '', url: FIXATIONS_PATHS.REQUESTS },
          ],
        },
      },
    ],
  },
]
